import Skeleton from '@/components/Skeleton/Skeleton.vue'

export default {
  name: 'WeeklyRewards',
  components: {
    Skeleton
  },
  props: ['rewards', 'rewardFormatted'],
  data () {
    return {
      skeletonRewards: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    }
  }
}
